import {
  ADFORM_PREBID_BIDDER,
  RTBHOUSE_PREBID_BIDDER,
  TABOOLA_PREBID_BIDDER,
  TURK_TELEKOM_PREBID_BIDDER,
  YANDEX_PREBID_BIDDER,
  INDEX_EXCHANGE_BIDDER,
  PUBMATIC_PREBID_BIDDER,
  THEADX_PREBID_BIDDER,
  ADMATIC_PREBID_BIDDER,
  ESKIMI_PREBID_BIDDER,
} from '../bidders';

export const tagAdUnits = {
  desktop: {
    labelsTop: {
      name: 'Onedio.com_Desktop_Labels_Top',
      sizes: ['fluid', [300, 250], [336, 280]],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666467),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_labels_mid_1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508961),
          THEADX_PREBID_BIDDER(756),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Labels_Top',
        },
      },
    },
    labelsMiddle1: {
      name: 'Onedio.com_Desktop_Labels_Middle1',
      sizes: [[300, 250], [336, 280], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666467),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_labels_mid_2'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508961),
          THEADX_PREBID_BIDDER(756),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Labels_Middle',
        },
      },
    },
    labelsMiddle2: {
      name: 'Onedio.com_Desktop_Labels_Middle2',
      sizes: [[300, 250], 'fluid', [336, 280]],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666467),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_labels_mid_3'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508961),
          THEADX_PREBID_BIDDER(756),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Labels_Middle',
        },
      },
    },
  },
  mobile: {
    labelsTop: {
      name: 'Onedio.com_Mobile_Labels_Top',
      sizes: [[300, 250], [336, 280], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_labels_mid_1'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508966),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Labels_Top',
        },
      },
    },
    labelsMiddle1: {
      name: 'Onedio.com_Mobile_Labels_Middle1',
      sizes: [[336, 280], 'fluid', [300, 250]],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_labels_mid_2'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508966),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Labels_Middle',
        },
      },
    },
    labelsMiddle2: {
      name: 'Onedio.com_Mobile_Labels_Middle2',
      sizes: [[336, 280], 'fluid', [300, 250]],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_labels_mid_3'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508966),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Labels_Middle',
        },
      },
    },
  },
};
